import React from 'react'

export default function downArrow(color, size, style=null, dataCategory=null) {
    return (<svg height={size} viewBox="0 0 48 48" width={size} xmlns="http://www.w3.org/2000/svg" style={style} data-category={dataCategory}>
        <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" stroke={color} fill={color} data-category={dataCategory}/>
        <path d="M0-.75h48v48h-48z" fill="none" data-category={dataCategory} />
    </svg>)
}